import * as React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import ReactModal from 'react-modal';
import styled, { css } from 'styled-components';
import CloseIcon from '../images/close.svg';

interface Props {
  isOpen: boolean;
  content: React.ReactNode;
  handleModal: (content: React.ReactNode | null) => void;
  copy: GatsbyTypes.MicrocopyFragment['registration'];
}

ReactModal.setAppElement('body');

export const Gradient = css`
  // #f0f0f024 is color-grey at .14 opacity
  background: repeating-linear-gradient(-45deg, transparent, transparent 40px, #f0f0f024 41px);
  background-size: 100% 250px;
  background-repeat: repeat-x;
`;

const StyledContent = styled.div`
  color: var(--color-white);
  width: 100%;
  height: 100%;
  position: relative;
  padding: 42px 20px;
  /* max-height: 750px; */

  ${Gradient}

  @media (min-width: 768px) {
    padding: 76px 0;
  }
`;

const CloseButton = styled.button`
  cursor: pointer;
  position: absolute;
  right: 1.69rem;
  top: 1.69rem;
`;

// overrides of the default Modal styles from react-modal
const baseStyles = {
  overlay: {
    // grey-darker with .8 opacity
    backgroundColor: '#1C2930CC',
    // one higher than guest/host profile pics
    zIndex: '30',
    overflow: 'auto',
  },
  content: {
    background: 'var(--color-grey-darker)',
    maxWidth: '941px',
    maxHeight: '800px',
    minHeight: '600px',
    margin: '0 auto',
    border: 'none',
    borderRadius: '0',
    padding: '0',
    inset: '7% 7% auto',
  },
};

const Modal = ({ isOpen, handleModal, content }: Props): JSX.Element => {
  return (
    <ReactModal
      onRequestClose={() => handleModal(null)}
      isOpen={isOpen}
      style={baseStyles}
      ariaHideApp={true}
      onAfterOpen={() => (document.body.style.overflow = 'hidden')}
      onAfterClose={() => (document.body.style.overflow = 'unset')}
    >
      <StyledContent>
        <CloseButton onClick={() => handleModal(null)} type="button">
          <CloseIcon />
        </CloseButton>
        {content}
      </StyledContent>
    </ReactModal>
  );
};

export default Modal;
